import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Upload from '../../../libCustom/upload';
import * as SalesActions from '../redux/SalesActions';

class filesInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  render() {
    const { Sales } = this.props;
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <Upload
                label={''}
                files={Sales.filesInvoice.length > 0 ? Sales.filesInvoice : []}
                directory={'facturas'}
                bucket={'loopback-rsviajes'}
                multiple={true}
                onChange={(files) =>
                  this.props.dispatch(
                    SalesActions.onChange(['filesInvoice'], files)
                  )
                }
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(filesInvoice);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/filesInvoice.js